import { render, staticRenderFns } from "./TraceFrame.vue?vue&type=template&id=93309e08&scoped=true"
import script from "./TraceFrame.vue?vue&type=script&lang=ts"
export * from "./TraceFrame.vue?vue&type=script&lang=ts"
import style0 from "./TraceFrame.vue?vue&type=style&index=0&id=93309e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93309e08",
  null
  
)

export default component.exports